import { KatIcon } from '@amzn/katal-react';
import { Environments } from './Environments';

export interface Marketplace {
  [Environments.prod]: string,
  [Environments.gamma]: string,
  [Environments.beta]: string,
  flag: KatIcon.Name,
}

export enum Marketplaces {
  australia = 'australia',
  belgium = 'belgium',
  brazil = 'brazil',
  canada = 'canada',
  egypt = 'egypt',
  france = 'france',
  germany = 'germany',
  india = 'india',
  italy = 'italy',
  japan = 'japan',
  mexico = 'mexico',
  netherlands = 'netherlands',
  poland = 'poland',
  saudi_arabia = 'saudi_arabia',
  singapore = 'singapore',
  spain = 'spain',
  sweden = 'sweden',
  turkey = 'turkey',
  uae = 'uae',
  uk = 'uk',
  usa = 'usa',
}
